"use client";

import { useTranslations } from "next-intl";
import { CustomDialog } from "@/components/custom/dialog";

interface TermsRevokeConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onCancelSignUp?: () => void;
}

export default function TermsRevokeConfirmDialog({
  open,
  onClose,
  onCancelSignUp,
}: TermsRevokeConfirmDialogProps) {
  const t = useTranslations("dialogs.termsRevoke");

  return (
    <CustomDialog
      open={open}
      onOpenChange={onClose}
      size="sm"
      classNameTitle="text-xl"
      title={t("title")}
      description={t("description")}
      cancelText={t("cancelText")}
      okText={t("okText")}
      okButtonVariant="destructive"
      onOkClick={() => {
        if (onCancelSignUp) onCancelSignUp();
      }}
    />
  );
}
